import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import { RouteErrorBoundary } from "./routes/RouteErrorBoundary";

const App = lazy(() => import("./App").then((m) => ({ default: m.App })));
const PublicApp = lazy(() =>
  import("./PublicApp").then((m) => ({ default: m.PublicApp })),
);

const OptOut = lazy(() =>
  import("screens/OptOut/OptOut").then((m) => ({ default: m.OptOut })),
);
const OptOutOfSaleOrSharing = lazy(() =>
  import("screens/OptOut/OptOutOfSaleOrSharing").then((m) => ({
    default: m.OptOutOfSaleOrSharing,
  })),
);
const OptOutOfProcessing = lazy(() =>
  import("screens/OptOut/OptOutOfProcessing").then((m) => ({
    default: m.OptOutOfProcessing,
  })),
);
const OptOutDelete = lazy(() =>
  import("screens/OptOut/OptOutDelete").then((m) => ({
    default: m.OptOutDelete,
  })),
);
const OptOutVerify = lazy(() =>
  import("screens/OptOut/OptOutVerify").then((m) => ({
    default: m.OptOutVerify,
  })),
);

export const router = createBrowserRouter([
  {
    path: "/opt-out",
    Component: PublicApp,
    children: [
      { index: true, Component: OptOut },
      {
        path: "opt-out-of-sale-or-sharing/:token",
        Component: OptOutOfSaleOrSharing,
      },
      { path: "opt-out-of-processing/:token", Component: OptOutOfProcessing },
      { path: "delete/:token", Component: OptOutDelete },
      { path: "verify/:token", Component: OptOutVerify },
    ],
  },
  { path: "*", Component: App, errorElement: <RouteErrorBoundary /> },
]);
